<template>
  <div class="salary-finance-progress-loader">
    <div class="content">
      <img
        src="../../../assets/salary-finance/salary-finance-logo.svg"
        class="salary-finance-logo"
        alt="Salary Finance Logo"
      >
      <progress-stage-loader
        :current-stage="props.progressState.currentStage"
        :completed-stages="props.progressState.completedStages"
        :error="props.progressState.error"
        :status-message="props.progressState.statusMessage"
        :flow-config="salaryFinanceFlowConfig"
        force-text-color="#002579"
        force-font-family="SalaryFinance"
      />
    </div>
  </div>
</template>

<script setup>
import Segment from '../../../Segment';
import ProgressStageLoader from '../../Common/ProgressStageLoader.vue';

const props = defineProps({
  jobId: {
    type: String,
    required: true,
  },
  progressState: {
    type: Object,
    required: true,
  },
});

const salaryFinanceFlowConfig = {
  title: 'Analyzing your data',
  description: 'This might take up to a few minutes to complete.',
  subDescription: 'We are processing your financial data to provide personalized insights and recommendations.',
  stageMessages: {
    scrape: 'Collecting your financial data...',
    versionUpdate: 'Validating and organizing your account information...',
    featurama: 'Analyzing your spending patterns to identify opportunities...',
    otis: 'Generating personalized recommendations for your financial goals...',
  },
};

// Track when component is entered
Segment.trackUserGot('SalaryFinanceProgressLoaderEntered');
</script>

<style lang="scss" scoped>
.salary-finance-progress-loader {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #EEF2F8; // Salary Finance specific background
}

.content {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.salary-finance-logo {
  width: 50%;
  margin-top: 25px;
  max-width: 200px;
}
</style>
